import React, { Component } from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import EditIcon from '@material-ui/icons/Edit';
import { cloneDeep, getCurrentPayCycle, UpdateColumnWithConfiguration, IsSectionVisible, isGridFormValid, applyFilterOnData, EnhancedTableHead, orderBy } from '../../utils/helper';
import { API_URL } from '../../constants/api';
import { ShowToast, toastType } from '../../utils/toast-service';
import { apiBatchRequest, apiPost, apiPut } from '../../utils/api_service';
import commonLabels from '../../constants/messageConstants';
import { controlType } from '../../constants/common';
import { GridTable } from '../common/Table/Table';
import { SECTIONS, ServiceTypes, DEPARTMENT } from '../../constants/appConstants';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { getFormattedValues } from '../../utils/formatData';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';
import { propertyTenantMappingColumnList } from '../../constants/MockData';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { IconButton, Tooltip, Button, Table, TableBody, TableCell, TableRow, TextField, Chip } from '@material-ui/core';

// This component is used to set AR admin and Tenant Count to the Properties
class PropertyTenantCountMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeMasterData: [],
      marketMasterData: [],
      propertyMasterData: [],
      payPeriodMasterData: [],
      propertyTenantData: [],
      propertyTenantMappingColumns: _.cloneDeep(propertyTenantMappingColumnList),
      openDialog: false,
      confirmationMessage: '',
      openAdminChangeConfirmDialog: false,
      adminChangeConfirmationMessage: ''
    };
  }

  // Get data from API before components are loading
  componentDidMount() {
    this.LoadData();
  }

  // Get data from APIs
  LoadData() {
    const selectedData = [];
    const date = getCurrentPayCycle();

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true&departmentId=' + DEPARTMENT.CENTRALIZED_AR,
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Allocation.GetPayPeriod,
        key: 'payPeriodData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData + '?serviceTypeId=' + ServiceTypes.Property_Accounting,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Property.GetPropertyTenantCount + '?periodStartDate=' + date[1],
        key: 'propertyTenantData'
      }
    ])
      .then(
        ({
          employeeMasterData,
          marketMasterData,
          payPeriodData,
          propertyMasterData,
          propertyTenantData
        }) => {
          this._asyncRequest = null;
          if (payPeriodData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            selectedData.push(
              {
                key: 'payPeriod',
                selected: (payPeriodData.data.find(x => x.payPeriod === (date[1] + '-' + date[0])) || {})
              }
            );
            // selectedData.push();
            this.setState({
              employeeMasterData: (employeeMasterData.data || []).filter(x=> x.terminationDate === null || (new Date(x.terminationDate) >= new Date(date[1]))),
              originalEmployeeMasterData: employeeMasterData.data || [],
              marketMasterData: marketMasterData.data || [],
              payPeriodData: (payPeriodData.data || []).filter(x => x.periodStartDate !== x.periodEndDate),
              propertyMasterData: propertyMasterData.data || [],
              propertyTenantData: propertyTenantData.data || [],
              responsePropertyTenantData: propertyTenantData.data || [],
              selectedData: selectedData || [],
              defaultSelectedData: cloneDeep(selectedData),
              configuration: propertyTenantData.config || [],
              selectedPayPeriodId: payPeriodData.data.find(x => x.payPeriod === (date[1] + '-' + date[0]))?.payPeriodId || 0
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Get Active Properties with assigned AR Admin and Property Counts for selected pay period
  GetPropertyTenantCountData = (periodStartDate, selectedData) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Property.GetPropertyTenantCount + '?periodStartDate=' + periodStartDate,
        key: 'propertyTenantData'
      }
    ])
      .then(({ propertyTenantData }) => {
        this.setState({
          propertyTenantData: propertyTenantData.data || [],
          responsePropertyTenantData: propertyTenantData.data || [],
          selectedData,
          order: 'asc',
          orderBy: null
        }, () => { this.onFilterChange(selectedData); });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  // Event to handle filter value change
  onFilterChange = (selectedData) => {
    let employeeMasterData = this.state.originalEmployeeMasterData;
    const responsePropertyTenantData = this.state.responsePropertyTenantData || [];
    const selectedPayPeriodId = this.state.selectedPayPeriodId;
    const newSelectedPayPeriodId = selectedData.find((x) => x.key === 'payPeriod')?.selected?.payPeriodId || 0;
    let periodStartDate, periodEndDate;

    if (selectedPayPeriodId === newSelectedPayPeriodId) {
      const filteredData = applyFilterOnData(
        responsePropertyTenantData,
        selectedData
      );
      this.setState({ propertyTenantData: filteredData, selectedData });
    } else {
      const selectedPayPeriod = selectedData.find((x) => x.key === 'payPeriod') || {};
      if (
        selectedPayPeriod &&
        selectedPayPeriod.selected
      ) {
        periodStartDate = selectedPayPeriod.selected.periodStartDate;
        periodEndDate = selectedPayPeriod?.selected?.periodEndDate;
        employeeMasterData = (employeeMasterData || []).filter(x=> x.terminationDate === null || (new Date(x.terminationDate) >= new Date(periodStartDate)));
        this.setState({ selectedPayPeriodId: newSelectedPayPeriodId, selectedData, employeeMasterData }, () => { this.GetPropertyTenantCountData(periodStartDate, selectedData); });
      }
    }
  }

  // Edit record
  EditRecord = (cellInfo) => {
    const propertyTenantMappingColumns = _.cloneDeep(propertyTenantMappingColumnList);

    this.setState({
      propertyTenantMappingColumns,
      selectedEditRowId: {
        key: 'arPropertyTenantMappingId',
        value: cellInfo.arPropertyTenantMappingId
      },
      isInAddMode: false,
      updateData: cellInfo,
      reloadTable: !this.state.reloadTable
    });
  }

  // Check whether Edit icon should be visible or not based on access permissions.
  isEditIconVisible = () => {
    if (IsSectionVisible(SECTIONS.CENTERALIZED_AR_PROPERTY_TENANT_MAPPING, 0, SECTIONS.ADD_EDIT)) {
      return true;
    }
    return false;
  }

  /**
  * render action column on grid table
  * @param {*} cellInfo
  * @param {*} isInAddMode
  * @returns
  */
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
          cellInfo.arPropertyTenantMappingId === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => { }}
                >
                  <SaveIcon
                    fontSize="small"
                    size="small"
                    onClick={this.saveUpdatedRecord}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={this.cancelEditMode}
                >
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
          )
          : <>
            { this.isEditIconVisible() && this.isPayCycleOpen() && (
              <Tooltip title="Edit Record">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                      ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>)
            }
          </>
        }
      </>
    );
  };

  /**
     * cancel row open for edit mode
     */
  cancelEditMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      reloadTable: !this.state.reloadTable,
      propertyTenantData: this.state.responsePropertyTenantData
    });
  };

  // Check whether selected Pay cycle is Open or Closed
  isPayCycleOpen = () => {
    const { payPeriodData, selectedData } = this.state;
    let payPeriod;
    const selectedPayPeriod = (selectedData || []).find((x) => x.key === 'payPeriod') || {};
    if (
      selectedPayPeriod &&
      selectedPayPeriod.selected
    ) {
      payPeriod = selectedPayPeriod.selected.payPeriod;
    }
    const payCycle = (payPeriodData || []).find(x => x.payPeriod === payPeriod);
    return payCycle !== undefined ? (!payCycle.isClosed) : false;
  }

  /**
 * is Form Valid
 */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, propertyTenantMappingColumns } = this.state;
    propertyTenantMappingColumns.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ propertyTenantMappingColumns }, this.forceUpdate());
    return IsValid;
  };

  // Check whether Form values are valid or not
    isValidFormWithMultipleRecords = (propertyTenantData) => {
    let formData = null;
    formData = this.prepareDataForFinalSave(propertyTenantData);

    if (formData.isValid === false) {
      ShowToast('Please enter valid data in field(s).', toastType.ERROR, 5000, 500);
    }
    return { isValid: formData.isValid, propertyTenantData: formData.data };
  }

  // Prepare all records data to bulk update into database
  prepareDataForFinalSave = (data) => {
    let formData = null;
    let isValid = true;
    data.map(x => {
      propertyTenantMappingColumnList.map(z => {
        formData = this.checkValidations(z, x);
        x = formData.x;
        if (isValid === true) {
          isValid = formData.isValid;
        }
        return z;
      });
      return x;
    });
    return { data, isValid };
  }

  /**
   * save Updated Record to database
   */
  saveUpdatedRecord = () => {
    if (!this.isValidForm()) { return false; } else {
      const newParam = this.state.updateData;
      const selectedData = this.state.selectedData;
      let periodStartDate;
      const selectedPayPeriod = selectedData.find((x) => x.key === 'payPeriod') || {};
      if (
        selectedPayPeriod &&
        selectedPayPeriod.selected
      ) {
        periodStartDate = selectedPayPeriod.selected.periodStartDate;
      }

      apiPost({
        url: API_URL.Property.UpdatePropertyTenantCount + '?propertyId=' + newParam.propertyId + '&tenantCount=' + newParam.tenantCount + '&employeeId=' + newParam.employeeId + '&periodStartDate=' + periodStartDate,
        postBody: newParam
      }
      ).then(({ data: response }) => {
        if (response.success === true) {
          ShowToast(
            this.state.isInAddMode
              ? 'Record added successfully.'
              : 'Record updated successfully.',
            toastType.SUCCESS,
            5000,
            500
          );

          this.setState({
            updateData: undefined,
            selectedEditRowId: undefined,
            reloadTable: !this.state.reloadTable,
            isInAddMode: false
          }, () => { this.GetPropertyTenantCountData(periodStartDate, selectedData); });
        } else {
          ShowToast(
            response.message,
            toastType.ERROR,
            5000,
            5000
          );
        }
      });
    }
  };

  /**
 * handle on change
 * @param {*} value
 * @param {*} fieldName
 */
  handleTableEditChange = (value, fieldName) => {
    const { propertyTenantMappingColumns } = this.state;
    const param = this.state.updateData;
    const validationMessage = this.state.validationMessage;
    param[fieldName] = value;
    isGridFormValid(value, propertyTenantMappingColumns.find(x => x.key === fieldName), param);

    this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) }, () => {
      this.forceUpdate();
    });
  };

  // Get column's configuration
  getColumns = (configuration) => {
    const columns = (UpdateColumnWithConfiguration(this.state.propertyTenantMappingColumns, configuration) || []).filter(x => x.isVisible === true);
    return columns;
  }

  // Handle sorting on table
  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      propertyTenantData: orderBy(this.state.propertyTenantData, property, isAsc ? 'desc' : 'asc')
    });
  };

  // Render table component with specified columns and selected filters
  renderTable = (propertyTenantData, configuration) => {
    const columns = this.getColumns(configuration, propertyTenantData);
    const EditSource = [];
    EditSource.push(
      { key: 'employeeMasterData', data: this.state.employeeMasterData }
    );
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          updateData={this.state.updateData}
          EditSource={EditSource}
          order={this.state.order}
          orderBy={this.state.orderBy}
          columnSequence={[]}
          onRequestSort={this.handleRequestSort}
          rowCount={propertyTenantData.length}
          headCells={columns}
        // onFilterChange={this.onControlChange}
        />
        <TableBody>
          {this.renderTableCell(propertyTenantData, columns, [], 0)}
        </TableBody>
      </Table>
    );
  };

  // Render table cell in ach row of the table
  renderTableCell = (groupedData, columns, tableCell = [], rowCount = 0) => {
    const EditSource = [];
    EditSource.push(
      { key: 'employeeMasterData', data: this.state.employeeMasterData }
    );
    groupedData.forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' evenRow ' : ' oddRow ';
      const key = i + '_' + d.arPropertyTenantMappingId + '_' + d.employeeId + '_' + d.propertyId + '_' + rowCount + '_' + i;
      tableCell.push(
        <TableRow key={key} >
          {
            columns.map((col, index) => {
              return (
                <>
                  <TableCell key={key + index} width={col.width || ''} className={evenOddClass + 'rpt-textColor' + ' property-tenant-padding'} >
                    {col.isEditable === true && this.isEditIconVisible() === true && this.isPayCycleOpen() === true && col.editConfig !== undefined
                      ? this.renderControl(d, col, EditSource)
                      : col.editConfig !== undefined && (col.editConfig.showBadge || (col.isEditable === true && d.isEditable === true && d.isFreezed === false && d.isRecentlyAdded === true))
                        ? this.renderControl(d, col, EditSource)
                        : col.renderComponent !== undefined && d.isFreezed === false && d.isEditable === true
                          ? this.renderActionColumn(d)
                          : getFormattedValues(d[col.key], col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')
                    }

                  </TableCell>
                </>
              );
            })
          }

        </TableRow>
      );
      rowCount++;
    });
    if (groupedData?.length <= 0) {
      tableCell.push(<TableRow> <TableCell colSpan={8} align='center'>No records found</TableCell> </TableRow>);
    }
    return tableCell;
  }

  // Render control based on control type
  renderControl = (d, col, dataSource) => {
    const format = col.editConfig.type;
    const dropdownData = dataSource.find(x => x.key === col.editConfig.sourceKey)?.data;
    switch ((format || '').trim()) {
      case controlType.TextNumber:
        return <TextField
          value={d[col.key]}
          margin="normal"
          className={'amount-text editable'}
          error={d[col.key + 'IsInErrorState']}
          helperText={d[col.key + 'ErrorMessage']}
          size="small"
          color="primary"
          type='Number'
          onChange={(e) => this.isNumberKey(e) ? this.onChangeValues(e.target.value, d, col) : ''}
        />;
      case controlType.Badge:
        return <Chip
          className={d.isOverride === false && (d.bonusAmount?.toString() === '0' || d.bonusAmount?.toString() === '0.0000') ? 'no-title' : d.isOverride === true ? 'override' : 'no-override'}
          size="small"
          style={{ width: '40px', cursor: 'pointer' }}
          label={getFormattedValues(d[col.key], col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
          title={d.isOverride === false && (d.bonusAmount?.toString() === '0' || d.bonusAmount?.toString() === '0.0000') ? 'No Bonus Percent Adjusted Against Title' : d.isOverride === true ? 'Bonus Percent/Amount is Override' : 'No Bonus Percent/Amount is Override'}
        />;
      case controlType.DropDown:
        return (
          <>
            <Autocomplete
              size="small"
              error={d[col.key + 'IsInErrorState']}
              helperText={d[col.key + 'ErrorMessage']}
              options={dropdownData.map(
                (option) => option[col.editConfig.sourceOption]
              )}
              value={d[col.key]}
              className="editable"
              key={'dropDown_filter' + col.editConfig.updateKey}
              id={'dropDown_filter' + col.editConfig.updateKey}
              onChange={(event, value) => {
                this.onChangeValues(value, d, col);
              }}
              autoHighlight
              renderInput={(params) => (
                <TextField
                  disabled={col.isEditable}
                  error={d[col.key + 'IsInErrorState']}
                  helperText={d[col.key + 'ErrorMessage']}
                  {...params}
                  margin="normal"
                  className="table-text"
                />
              )}
            />
          </>
        );
    }
  }

  // Apply regex for numberic value selection 
  isNumberKey = (evt) => {
    if (evt.target.value.length >= 6) {
      return false;
    }
    if (evt.target.value === '') {
      return true;
    } else {
      const numericInput = new RegExp('^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,4}))))\\s*$');
      return numericInput.test(evt.target.value);
    }
  }

  // Handle event of Confirmation dialog box value selection
  onAdminChangeConfirmed = (isConfirmed) => {
    if (isConfirmed) {
      const { propertyTenantData, responsePropertyTenantData, changeObj } = this.state;
      this.setState({
        openAdminChangeConfirmDialog: false,
        adminChangeConfirmationMessage: '',
        propertyTenantData: this.prepareDataOnChange(propertyTenantData, changeObj?.data, changeObj?.col, changeObj?.value),
        responsePropertyTenantData: this.prepareDataOnChange(responsePropertyTenantData, changeObj?.data, changeObj?.col, changeObj?.value)
      }, this.forceUpdate());
    } else {
      this.setState({
        openAdminChangeConfirmDialog: false,
        adminChangeConfirmationMessage: '',
        changeObj: null
      }, this.forceUpdate());
    }
  }

  // Handle event when filter value is changed
  onChangeValues = (value, data, col) => {
    const { propertyTenantData } = this.state;
    if (col.dbColumn === 'EmployeeName' && data.employeeId > 0 && data.employeeName !== null) {
      let confirmationMessage = '';
      if (value === null) {
        confirmationMessage = data.employeeName + ' is assigned as a AR Admin to the property ' + data.propertyName + '. Do you want to unassign the AR Admin?';
      } else {
        confirmationMessage = data.employeeName + ' is assigned as a AR Admin to the property ' + data.propertyName + '. Do you want to change AR Admin as ' + value + '?';
      }
      this.setState({
        openAdminChangeConfirmDialog: true,
        adminChangeConfirmationMessage: confirmationMessage,
        changeObj: { value: value, data: data, col: col }
      });
    } else {
      this.setState({
        propertyTenantData: this.prepareDataOnChange(propertyTenantData, data, col, value)
      }, this.forceUpdate());
    }
  }

  // Check validations when filter values are changed and prepare the data model to save.
  prepareDataOnChange = (propertyTenantData, data, col, value) => {
    propertyTenantData.map(x => {
      if (x.arPropertyTenantMappingId === data.arPropertyTenantMappingId) {
        x[col.key] = (col.dataFormat === 'Number' && isNaN(value) === false && value !== '') ? parseInt(value) : value;
        if (col.dbColumn === 'EmployeeName') {
          x.employeeId = this.state.employeeMasterData.find(y => y.employeeName === value)?.employeeId || 0;
        }
        x = (this.checkValidations(col, x) || {}).x;
      }
      return x;
    });
    return propertyTenantData;
  }

  // Check validations
  checkValidations = (col, x) => {
    let isValid = true;
    if (col.isRequired === true) {
      if (col.dataFormat === 'Number' && (parseInt(x[col.key]) < 0 || x[col.key] === undefined || x[col.key] === '' || x[col.key] === null)) {
        x[col.key + 'IsInErrorState'] = true;
        x[col.key + 'ErrorMessage'] = 'Required.';
        isValid = false;
      } else if (x[col.key] === undefined || x[col.key] === '' || x[col.key] === null) {
        x[col.key + 'IsInErrorState'] = true;
        x[col.key + 'ErrorMessage'] = 'Required.';
        isValid = false;
      } else {
        x[col.key + 'IsInErrorState'] = false;
        x[col.key + 'ErrorMessage'] = '';
      }
    } 
    if(col.key === 'tenantCount') {
       if((x.tenantCount || 0) > 0 && (x.employeeName === undefined || x.employeeName === '' || x.employeeName === null)) {
          x['employeeName' + 'IsInErrorState'] = true;
          x['employeeName' + 'ErrorMessage'] = 'Required.';
          isValid = false;
       } else if ((x.tenantCount || 0) === 0) {
        x['employeeName' + 'IsInErrorState'] = false;
        x['employeeName' + 'ErrorMessage'] = '';        
       }
    }
    else if (col.key === 'employeeName') {
      if((x.tenantCount || 0) > 0 && (x[col.key] === undefined || x[col.key] === '' || x[col.key] === null)) {
        x[col.key + 'IsInErrorState'] = true;
        x[col.key + 'ErrorMessage'] = 'Required.';
        isValid = false;
      } else {
        x[col.key + 'IsInErrorState'] = false;
        x[col.key + 'ErrorMessage'] = '';
      }
    }
    return { x, isValid };
  }

  // Submit button click event to handle submission of records
  onSubmitClick = () => {
    const formData = this.isValidFormWithMultipleRecords(this.state.propertyTenantData);
    if (formData !== '' && formData.isValid === false) {
      let filterToBeChanged = this.state.selectedData;
      // filterToBeChanged = filterToBeChanged.filter(x => (this.state.defaultSelectedData || []).find(y => y.key === x.key)) || [];
      this.setState({
        propertyTenantData: orderBy(formData.propertyTenantData, 'employeeNameErrorMessage', 'desc'),
        responsePropertyTenantData: orderBy(this.state.responsePropertyTenantData, 'employeeNameErrorMessage', 'desc'),
        order: 'desc',
        orderBy: 'employeeNameErrorMessage'
      }, () => { this.onFilterChange(filterToBeChanged); });
    } else {
      this.setState({
        openDialog: true,
        confirmationMessage: 'Do you want to save Property Tenant Mapping?'
      });
    }
  }

  // Handle confirmation button click event
  onConfirmClickHandle = (value) => {
    if (value) {
      this.setState({
        openDialog: false,
        confirmationMessage: ''
      }, () => {
        this.savePropertyTenantCountMapping();
      });
    } else {
      this.setState({
        openDialog: false,
        confirmationMessage: '',
        resetDefault: false
      });
    }
  }

  // Save Property - Tenant Count - AR admin mapping data
  savePropertyTenantCountMapping = () => {
    const selectedData = this.state.selectedData;
    let periodStartDate;
    const selectedPayPeriod = selectedData.find((x) => x.key === 'payPeriod') || {};
    if (
      selectedPayPeriod &&
      selectedPayPeriod.selected
    ) {
      periodStartDate = selectedPayPeriod.selected.periodStartDate;
    }
    apiPut(API_URL.Property.UpdatePropertyTenantMapping, this.state.propertyTenantData)
      .then(({ data: response }) => {
        if (response.success) {
          ShowToast('Property Tenant Mapping updated successfully', toastType.SUCCESS, 5000, 500);
          let filterToBeChanged = selectedData.filter(x => (this.state.defaultSelectedData || []).find(y => y.key === x.key)) || [];
          this.GetPropertyTenantCountData(periodStartDate, filterToBeChanged);
        } else {
          ShowToast(response.message, toastType.ERROR, 5000, 500);
        }
      });
  }

  // Render components based on conditions
  render() {
    const {
      employeeMasterData,
      marketMasterData,
      selectedData,
      configuration,
      payPeriodData,
      propertyMasterData,
      defaultSelectedData,
      propertyTenantData,
      propertyTenantMappingColumns
    } = this.state;
    const EditSource = [];
    EditSource.push({
      key: 'employeeMasterData',
      data: employeeMasterData
    });

    return (
      <>
        <ConfirmDialog
          IsOpen={this.state.openDialog}
          Message={this.state.confirmationMessage}
          OnHandelClick={(isValid) => {
            if (isValid) {
              this.onConfirmClickHandle(isValid);
            } else {
              this.onConfirmClickHandle(isValid);
            }
          }}
          AgreeText="Yes"
          DisAgreeText="No"
        />
        <ConfirmDialog
          IsOpen={this.state.openAdminChangeConfirmDialog}
          Message={this.state.adminChangeConfirmationMessage}
          OnHandelClick={(isConfirmed) => {
            this.onAdminChangeConfirmed(isConfirmed);
          }}
          AgreeText="Yes"
          DisAgreeText="No"
        />
        <PageHeader title="Property Tenant Mapping"></PageHeader>
        <PageFilter
          autoFilter={false}
          filterAlwaysVisible={true}
          onFilterChanged={this.onFilterChange}
          hidePanel={true}
          filterConfig={[
            {
              multiple: true,
              type: controlType.DropDown,
              source: marketMasterData,
              key: 'marketName',
              placeholder: 'Search Market',
              title: 'Market',
              disableClearable: false
            },
            {
              multiple: true,
              type: controlType.DropDown,
              source: propertyMasterData,
              key: 'propertyName',
              placeholder: 'Search Property',
              title: 'Property',
              disableClearable: false
            },
            {
              multiple: false,
              type: controlType.DropDown,
              source: payPeriodData,
              key: 'payPeriod',
              placeholder: 'Pay Period',
              title: 'Pay Period',
              ignoreSort: true,
              disableClearable: true
              // isHandleClick: true
            }

          ]}
          defaultSelectedData={defaultSelectedData}
          selectedData={selectedData}
          gridColumn={3}
        />
        <div>
          <div className="col-xs-12 col-lg-12 end-xs">
            {this.isEditIconVisible() === true && this.isPayCycleOpen() === true &&
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<SaveIcon />}
                onClick={() => { this.onSubmitClick(); }}
              > Save Records
              </Button>}
          </div>
          {false &&
            <GridTable
              validationMessage={this.state.validationMessage || []}
              columns={UpdateColumnWithConfiguration(
                propertyTenantMappingColumns,
                configuration
              )}
              data={propertyTenantData}
              renderActionColumn={this.renderActionColumn}
              selectedEditRowId={this.state.selectedEditRowId}
              isInAddMode={this.state.isInAddMode}
              EditSource={EditSource}
              handleTableEditChange={this.handleTableEditChange}
              updateData={this.state.updateData}
              isInline={true}
              reload={this.state.reloadTable}
            >
            </GridTable>
          }

          <div className="container year-end-bonus" style={{ marginTop: '1rem' }}>
            {this.renderTable(propertyTenantData, configuration)}
          </div>

        </div>
      </>
    );
  }
}

export default PropertyTenantCountMapping;